import styled from 'styled-components';

export const Container = styled.div`
  .ddi-container {
    width: 82px;
    max-width: 82px;
  }
`;
